module.exports = __webpack_public_path__ + "static/media/edu_blank.b4e3cf4d.svg";